import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var PhoneCall = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M12.99 2v2C17.052 4 20 6.943 20 10.999h2C22 5.869 18.127 2 12.99 2z", key: "k0" }),
        React.createElement("path", { d: "M16 11h2c0-3.225-1.775-5-5-5v2c2.103 0 3 .897 3 3zm-5.586-2.293L5 3.293l-.701.701-1 1a.991.991 0 0 0-.291.649c-.015.25-.302 6.172 4.291 10.766 4.006 4.006 9.024 4.299 10.406 4.299.202 0 .326-.006.358-.008a.994.994 0 0 0 .649-.291l1-1 .697-.697-5.414-5.414-.697.697-1.66 1.66c-.577-.109-1.734-.471-2.926-1.66-1.193-1.193-1.553-2.354-1.661-2.926l1.661-1.66.702-.702z", key: "k1" })));
});
PhoneCall.displayName = 'PhoneCall';
export var PhoneCallDimensions = { height: 24, width: 24 };
